"use client";

import React from "react";
import { ArrowRight, Rocket } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TuNegocioEnAlicanteDespegando() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll();
  return <section data-section-id="29756" id="especialistas-en-reparación-de-baterías-de-litio-en-sevilla-andalucía-y-españa" className="relative min-h-[90vh] w-full overflow-hidden bg-background flex items-center dark">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_10%_20%,var(--primary)_0%,transparent_40%)] opacity-20" />
        <div className="absolute bottom-0 right-0 w-full h-full bg-[radial-gradient(circle_at_90%_80%,var(--chart-2)_0%,transparent_40%)] opacity-10" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 h-full py-12 lg:py-0">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center h-full">
          
          {}
          <div ref={textRef} className={`lg:col-span-7 flex flex-col justify-center space-y-8 transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-primary/10 text-primary text-sm font-medium w-fit border border-primary/20">
                <span className="relative flex h-2 w-2">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-primary opacity-75"></span>
                  <span className="relative inline-flex rounded-lg h-2 w-2 bg-primary"></span>
                </span>
                Especialistas en reparación de baterías en Sevilla y también en Mairena del Aljarafe y Aljarafe
              </div>
              
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tighter leading-[1.1] text-foreground font-serif">
                Reparación de baterías de patinetes eléctricos en{" "}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[var(--primary)] via-[var(--chart-2)] to-[var(--chart-2)]">
                  Sevilla, Andalucía y España, Mairena del Aljarafe y Aljarafe
                </span>
              </h1>
              
              <p className="text-xl text-muted-foreground font-medium max-w-2xl leading-relaxed font-default">
                Somos tu servicio técnico patinetes eléctricos Sevilla de confianza. Nos especializamos en reparar batería patinete Sevilla y bicicletas con diagnóstico profesional, equilibrado de celdas y reparación baterías Sevilla. Si tu batería se apaga o ha perdido autonomía, te damos solución sin necesidad de comprar una nueva. Atendemos también a Mairena del Aljarafe y al resto del Aljarafe.
              </p>
              <p className="text-sm font-semibold text-primary/80 mt-4 font-default">
                Diagnóstico desde 20€ | Reparación sin cambiar batería | Servicio en Sevilla y en Mairena del Aljarafe.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <div className="relative group">
                <div className="absolute -inset-1 bg-gradient-to-r from-[var(--primary)] to-[var(--chart-2)] rounded-lg blur-md opacity-40 group-hover:opacity-70 transition duration-1000 group-hover:duration-200"></div>
                <Button asChild size="lg" className="relative w-full sm:w-auto text-lg h-14 px-8 bg-primary hover:bg-primary/90 text-primary-foreground transition-all hover:scale-[1.02] rounded-sm font-default">
                  <Link to="https://wa.me/34624990509">
                    Solicitar diagnóstico
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Link>
                </Button>
              </div>
              
              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-lg h-14 px-8 border-2 border-primary/30 hover:bg-primary/5 hover:border-primary/60 text-foreground transition-colors rounded-sm font-default">
                <Link to="https://wa.me/34624990509">
                  Reparar mi batería
                </Link>
              </Button>
            </div>

            <div className="flex items-center gap-8 pt-8 border-t border-border/30">
              <div>
                <p className="text-3xl font-bold text-foreground font-default">100%</p>
                <p className="text-sm text-muted-foreground font-default uppercase tracking-wider">Diagnóstico</p>
              </div>
              <div className="w-px h-10 bg-border/30"></div>
              <div>
                <p className="text-3xl font-bold text-foreground font-default">+1000</p>
                <p className="text-sm text-muted-foreground font-default uppercase tracking-wider">Baterías Reparadas</p>
              </div>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`lg:col-span-5 relative h-[300px] sm:h-[400px] lg:h-[700px] w-full flex items-center justify-center transition-all duration-1000 delay-300 ease-out ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            {}
            <div className="relative w-full h-full">
              {}
              <div className="absolute inset-0 rounded-3xl overflow-hidden shadow-2xl transform rotate-2 transition-transform hover:rotate-0 duration-700 border border-white/5">
                <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent z-10" />
                <img src="/img/reparacion_de_baterias_en_sevilla.webp" width={800} height={600} alt="reparación batería patinete Sevilla" title="reparación de baterías en Sevilla" data-description="Fondo desenfocado de un taller técnico especializado en la reparación de baterías de litio en Sevilla." className="w-full h-full object-cover scale-110 blur-sm opacity-40" fetchpriority="high" />
              </div>

              {}
              <div className="absolute inset-0 flex items-center justify-center z-20">
                <div className="relative w-4/5 h-4/5 animate-[float_6s_ease-in-out_infinite]">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626966/img/electric_scooter_battery_repair_cells.png" width={600} height={600} alt="baterías litio Sevilla" title="reparar batería patinete eléctrico" data-description="Composición técnica detallada que muestra la estructura interna de una batería de patinete eléctrico profesional." className="w-full h-full object-contain drop-shadow-[0_0_50px_rgba(var(--primary),0.3)]" />
                  
                  {}
                  <div className="absolute -top-10 -right-10 p-4 bg-card/40 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/10 animate-[float_8s_ease-in-out_infinite_reverse]">
                    <Rocket className="w-8 h-8 text-primary" />
                  </div>
                  
                  <div className="absolute bottom-10 -left-5 p-4 bg-primary/10 backdrop-blur-md rounded-sm shadow-xl border border-primary/20 text-primary text-xs font-bold animate-[float_7s_ease-in-out_infinite_1s] uppercase tracking-widest font-default">
                    Tecnología <br /> de Precisión
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}